"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ty = require("./assert-type");
exports.T = ty.Assert;
var BinaryReader = (function () {
    function BinaryReader(schemas, buffer) {
        this.strictMode = false;
        this.buffer = null;
        this.idx = 0;
        this.schemas = {};
        this.schemas = schemas;
        this.buffer = buffer;
        if (this.buffer !== undefined)
            this.dataView = new DataView(this.buffer.buffer);
    }
    BinaryReader.prototype.decode = function (schema, buffer) {
        // this.storeSchemas(schema);
        this.buffer = new Uint8Array(buffer);
        this.dataView = new DataView(this.buffer.buffer);
        this.idx = 0;
        return this.readDatum(schema);
    };
    BinaryReader.prototype.readByte = function () {
        return this.buffer[this.idx++];
        //return this.buffer.charCodeAt(this._index++);
    };
    BinaryReader.prototype.typeOf = function (value) {
        var s = typeof value;
        if (s === 'object') {
            if (value) {
                if (value instanceof Array) {
                    s = 'array';
                }
            }
            else {
                s = 'null';
            }
        }
        return s;
    }; // typeOf
    BinaryReader.prototype.read32le = function () {
        var b;
        var v = 0;
        var i;
        for (i = 0; i < 32; i += 8) {
            b = this.readByte();
            v |= (b << i);
        }
        return v;
    };
    // Reads count for array and map
    BinaryReader.prototype.readCount = function () {
        var count = this.readLong();
        if (count < 0) {
            this.readLong();
            count = -count;
        }
        return count;
    };
    BinaryReader.prototype.readBoolean = function () {
        return (this.readByte() === 1);
    };
    BinaryReader.prototype.readInt = function () {
        var i;
        var b = this.readByte();
        var n = b & 0x7f;
        for (i = 7; i <= 28 && b > 0x7f; i += 7) {
            b = this.readByte();
            n |= (b & 0x7f) << i;
        }
        if (b > 0x7f) {
            throw "Invalid int encoding.";
        }
        return (n >>> 1) ^ -(n & 1);
    };
    BinaryReader.prototype.readLong = function () {
        // using integer math instead
        // of bitwise operations allows us to go
        // quite a bit higher in the value.
        var b = this.readByte();
        var n = b & 0x7F;
        //console.log(n);
        var negative = (b & 0x01) == 0x01;
        var shift = 128;
        while ((b & 0x80) !== 0) {
            b = this.readByte();
            //n |= (b & 0x7F) << shift
            n += (b & 0x7f) * shift;
            //console.log(((b & 0x7f)*shift) + ":" + shift);
            shift *= 128;
        }
        //if(n<0xffffffff)
        //    return (n >> 1) ^ -(n & 1)
        if (negative)
            return Math.ceil(n / 2) * -1;
        return n / 2;
    };
    BinaryReader.prototype.readFloat = function () {
        var result = this.dataView.getFloat32(this.idx, true);
        this.idx += 4;
        return result;
    };
    BinaryReader.prototype.readDouble = function () {
        var result = this.dataView.getFloat64(this.idx, true);
        this.idx += 8;
        return result;
    };
    BinaryReader.prototype.readFixed = function (len) {
        var result = [];
        var i;
        for (i = 0; i < len; i++) {
            result.push(this.readByte());
        }
        return result;
    };
    BinaryReader.prototype.readBytes = function () {
        var length = this.readLong();
        var retVal = new Uint8Array(this.buffer.buffer, this.idx, length);
        this.idx += length;
        return retVal;
    };
    BinaryReader.prototype.readString = function () {
        var buff = this.readBytes();
        return new Buffer(buff).toString('utf-8');
    };
    BinaryReader.prototype.readEnum = function () {
        return this.readInt();
    };
    BinaryReader.prototype.readArrayStart = function () {
        return this.readCount();
    };
    BinaryReader.prototype.arrayNext = function () {
        return this.readCount();
    };
    BinaryReader.prototype.readMapStart = function () {
        return this.readCount();
    };
    BinaryReader.prototype.mapNext = function () {
        return this.readCount();
    };
    BinaryReader.prototype.readArray = function (schema) {
        var result = [];
        var i = this.readArrayStart();
        while (i !== 0) {
            while (i-- > 0) {
                result.push(this.readDatum(schema.items));
            }
            i = this.arrayNext();
        }
        return result;
    };
    BinaryReader.prototype.readDatum = function (schema) {
        var type;
        var i;
        var result;
        type = this.typeOf(schema);
        switch (type) {
            case "object":
                type = schema.type;
                break;
            case "string":
                type = schema;
                break;
            case "array":
                type = "union";
                break;
            default:
                throw "R:Invalid schema type: " + type;
        }
        if (type == "null") {
            return null;
        }
        else if (type == "boolean") {
            return this.readBoolean();
        }
        else if (type == "int") {
            return this.readInt();
        }
        else if (type == "long") {
            return this.readLong();
        }
        else if (type == "float") {
            return this.readFloat();
        }
        else if (type == "double") {
            return this.readDouble();
        }
        else if (type == "bytes") {
            return this.readBytes();
        }
        else if (type == "string") {
            return this.readString();
        }
        else if (type == "record") {
            result = {};
            for (i = 0; i < schema.fields.length; i++) {
                result[schema.fields[i].name] = this.readDatum(schema.fields[i].type);
            }
            return result;
        }
        else if (type == "enum") {
            return schema.symbols[this.readEnum()];
        }
        else if (type == "array") {
            return this.readArray(schema);
        }
        else if (type == "map") {
            result = {};
            i = this.readMapStart();
            while (i !== 0) {
                while (i-- > 0) {
                    result[this.readDatum("string")] = this.readDatum(schema.values);
                }
                i = this.mapNext();
            }
            return result;
        }
        else if (type == "union") {
            var idx = this.readLong();
            var result;
            if (schema[idx] == "null") {
                result = null;
            }
            else if (schema.length == 2 && schema[0] == 'null' && idx == 1) {
                result = this.readDatum(schema[1]);
            }
            else {
                result = {};
                result[schema[idx]] = this.readDatum(schema[idx]);
            }
            return result;
        }
        else {
            if (this.schemas[type] === undefined) {
                throw "Unsupported schema type " + type;
            }
            return this.readDatum(this.schemas[type]);
        }
    };
    return BinaryReader;
}());
exports.BinaryReader = BinaryReader;
var BinaryWriter = (function () {
    function BinaryWriter(schemas) {
        this.buffer = new Uint8Array(2048);
        this._index = 0;
        this.schemas = {};
        this.dataView = new DataView(this.buffer.buffer);
        if (schemas !== undefined) {
            this.schemas = schemas;
        }
    }
    BinaryWriter.prototype.getBuffer = function () {
        var buffer = new Buffer(this._index);
        for (var i = 0; i < this._index; ++i) {
            buffer[i] = this.buffer[i];
        }
        return buffer;
    };
    BinaryWriter.prototype.getArrayBuffer = function () {
        var ab = this.buffer.buffer;
        return ab.slice(0, this._index);
    };
    BinaryWriter.prototype.alloc = function (size) {
        this.buffer = new Uint8Array(size);
        this.dataView = new DataView(this.buffer.buffer);
    };
    BinaryWriter.prototype.realloc = function (size) {
        var old = this.buffer;
        this.alloc(size * 1.6);
        this.buffer.set(old);
    };
    BinaryWriter.prototype.require = function (bytes) {
        if (this.buffer.length < this._index + bytes) {
            this.realloc(this._index + bytes);
        }
    };
    BinaryWriter.prototype.encode = function (schema, datum) {
        this._index = 0;
        this.writeDatum(schema, datum);
        return this.buffer.subarray(0, this._index);
    };
    BinaryWriter.prototype.writeByte = function (b) {
        this.require(1);
        this.buffer[this._index++] = b;
    };
    BinaryWriter.prototype.writeBoolean = function (value) {
        this.writeByte(value ? 1 : 0);
    };
    BinaryWriter.prototype.writeInt = function (value) {
        var n = ((value << 1) ^ (value >> 31));
        while ((n & ~0x7F) !== 0) {
            this.writeByte(((n & 0x7f) | 0x80));
            n >>= 7;
        }
        this.writeByte(n);
    };
    BinaryWriter.prototype.writeLong = function (value) {
        var n;
        if ((value & 0xffffffff) == value) {
            this.writeInt(value);
        }
        else {
            if (value > 0) {
                n = 2 * value;
            }
            else {
                n = Math.round((2 * Math.abs(value)) - 1);
            }
            while (n > 0x7F) {
                this.writeByte(((n & 0x7f) | 0x80));
                n /= 128;
            }
            this.writeByte(n & 0x7f);
        }
    };
    BinaryWriter.prototype.writeFloat = function (f) {
        this.require(4);
        this.dataView.setFloat32(this._index, f, true);
        this._index += 4;
    };
    BinaryWriter.prototype.writeDouble = function (value) {
        this.require(8);
        this.dataView.setFloat64(this._index, value, true);
        this._index += 8;
    };
    BinaryWriter.prototype.writeBytes = function (bytes) {
        this.writeLong(bytes.length);
        this.require(bytes.length);
        this.buffer.set(bytes, this._index);
        this._index += bytes.length;
    };
    BinaryWriter.prototype.writeString = function (str) {
        if (str == null || str.length == 0) {
            this.writeInt(0);
            return;
        }
        // default encoding is utf-8
        var buff = new Buffer(str);
        this.writeBytes(new Uint8Array(buff));
    };
    BinaryWriter.prototype.writeIndex = function (idx) {
        this.writeInt(idx);
    };
    BinaryWriter.prototype.writeMapStart = function () {
        // To Be Implemented
    };
    BinaryWriter.prototype.writeMapEnd = function () {
        // To Be Implemented
    };
    BinaryWriter.prototype.writeDatum = function (schema, datum) {
        var type;
        var i;
        var result;
        function typeOf(value) {
            var s = typeof value;
            if (s === 'object') {
                if (value) {
                    if (value instanceof Array) {
                        s = 'array';
                    }
                }
                else {
                    s = 'null';
                }
            }
            return s;
        } // typeOf
        type = typeOf(schema);
        if (type === "object") {
            type = schema.type;
        }
        else if (type === "string") {
            type = schema;
        }
        else if (type === "array") {
            type = "union";
        }
        else if (type === "undefined") {
            throw "W:Undefined schema type " + schema;
        }
        else {
            throw "W:Unrecognized schema type: " + type + schema;
        }
        switch (type) {
            // Primitive types
            case "null":
                break;
            case "boolean":
                this.writeBoolean(datum);
                break;
            case "int":
                this.writeInt(datum);
                break;
            case "long":
                this.writeLong(datum);
                break;
            case "float":
                this.writeFloat(datum);
                break;
            case "double":
                this.writeDouble(datum);
                break;
            case "bytes":
                this.writeBytes(datum);
                return;
            case "string":
                this.writeString(datum);
                return;
            // Complex types
            case "record":
                for (i = 0; i < schema.fields.length; i++) {
                    this.writeDatum(schema.fields[i].type, datum[schema.fields[i].name]);
                }
                return;
            case "enum":
                for (i = 0; i < schema.symbols.length; i++) {
                    if (schema.symbols[i] == datum) {
                        this.writeInt(i);
                        return;
                    }
                }
                if ((parseInt(datum) >= 0) && (parseInt(datum) < schema.symbols.length)) {
                    this.writeInt(datum);
                    return;
                }
                throw new Error("Invalid enum value: " + datum + " expecting: " + schema.symbols);
            case "array":
                // Friendly for javascript null array === zero-length array
                if (datum && datum.length > 0) {
                    this.writeLong(datum.length);
                    for (i = 0; i < datum.length; i++) {
                        this.writeDatum(schema.items, datum[i]);
                    }
                }
                this.writeLong(0);
                return;
            case "map":
                var count = 0;
                for (var thisVar in datum) {
                    if (datum.hasOwnProperty(thisVar)) {
                        ++count;
                    }
                }
                if (count > 0) {
                    this.writeLong(count);
                    for (var k in datum) {
                        this.writeString(k);
                        this.writeDatum(schema.values, datum[k]);
                    }
                }
                this.writeLong(0);
                break;
            case "union":
                /// Special handling for nullable unions in ETP
                if (schema[0] == 'null') {
                    if (datum == null) {
                        this.writeLong(0);
                        return;
                    }
                    else if ((schema.length == 2) && (!(datum.hasOwnProperty(schema[1])))) {
                        this.writeLong(1);
                        this.writeDatum(schema[1], datum);
                        return;
                    }
                }
                for (i = 0; i < schema.length; i++) {
                    if (datum && datum.hasOwnProperty(schema[i])) {
                        this.writeLong(i);
                        this.writeDatum(schema[i], datum[schema[i]]);
                        return;
                    }
                }
                throw "Invalid value " + datum + " for union: " + schema;
            default:
                if (this.schemas[type] === undefined) {
                    throw "Unsupported schema type " + type;
                }
                this.writeDatum(this.schemas[type], datum);
        }
    };
    return BinaryWriter;
}());
exports.BinaryWriter = BinaryWriter;
var SchemaCache = (function () {
    //schemas: Object = {};
    function SchemaCache(schemaArray) {
        for (var i = 0; i < schemaArray.length; i++) {
            this.store(schemaArray[i]);
        }
    }
    SchemaCache.prototype.importSchemas = function (filePath) {
    };
    SchemaCache.prototype.store = function (schema) {
        var fullName = schema.namespace ? (schema.namespace + "." + schema.name) : schema.name;
        if (fullName !== undefined) {
            this[fullName] = schema;
            if (schema.fields !== undefined)
                for (var i = 0; i < schema.fields.length; i++) {
                    this.store(schema.fields[i].type);
                }
        }
    };
    SchemaCache.prototype.validate = function (schema, datum) {
        var type;
        var result;
        function typeOf(value) {
            var s = typeof value;
            if (s === 'object') {
                if (value) {
                    if (value instanceof Array) {
                        s = 'array';
                    }
                }
                else {
                    s = 'null';
                }
            }
            return s;
        } // typeOf
        type = typeOf(schema);
        if (type === "object") {
            type = schema.type;
        }
        else if (type === "string") {
            type = schema;
        }
        else if (type === "array") {
            type = "union";
        }
        else if (type === "undefined") {
            throw "W:Undefined schema type " + schema;
        }
        else {
            throw "W:Unrecognized schema type: " + type + schema;
        }
        switch (type) {
            // Primitive types
            case "null":
                return exports.T(ty.null)(datum);
            case "boolean":
                exports.T(ty.bool)(datum);
                return true;
            case "int":
            case "long":
                exports.T(ty.int)(datum);
                break;
            case "float":
            case "double":
                exports.T(ty.num.not.nan)(datum);
                break;
            case "bytes":
            case "string":
                exports.T(ty.str)(datum);
                return;
            // Complex types
            case "record":
                for (var i = 0; i < schema.fields.length; i++) {
                    this.validate(schema.fields[i].type, datum[schema.fields[i].name]);
                }
                return;
            case "enum":
                for (var i = 0; i < schema.symbols.length; i++) {
                    if (schema.symbols[i] == datum) {
                        return;
                    }
                }
                throw "Invalid enum value: " + datum + " expecting: " + schema.symbols;
            case "array":
                if (datum.length > 0) {
                    for (var i = 0; i < datum.length; i++) {
                        this.validate(schema.items, datum[i]);
                    }
                }
                return;
            case "map":
                var count = 0;
                for (var thisVar in datum) {
                    if (datum.hasOwnProperty(thisVar)) {
                        ++count;
                    }
                }
                if (count > 0) {
                    for (var k in datum) {
                    }
                }
                break;
            case "union":
                for (var i = 0; i < schema.length; i++) {
                    if (datum == null && schema[i] === 'null') {
                        return;
                    }
                    if (datum && datum[schema[i]] != undefined) {
                        return;
                    }
                }
                throw "Invalid value " + datum + " for union: " + schema;
            default:
                if (this[type] === undefined) {
                    throw "Unsupported schema type " + type;
                }
                this.validate(this[type], datum);
        }
    };
    return SchemaCache;
}());
exports.SchemaCache = SchemaCache;
//# sourceMappingURL=etp-avro.js.map